import { UiModal, UiModalRef, modalBreakpoint } from './Atoms/Modal';

const config = {
  modalBreakpoint,
};
export type { UiModalRef };
export { UiModal, config };
